<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/stop.svg" size="2"></app-svg>

  <h1>Cancel & Undo</h1>
  <p>Are you sure? Confirming will cancel and undo this upload.</p>

  <button
    appButton
    name="confirm"
    location="cancel-upload-dialog"
    color="warn"
    (click)="close(true)"
    height="4"
    shape="round"
    size="3"
    weight="bold"
    spacing="full"
  >
    Confirm
  </button>
</div>
